import SEOMetadata from '@/components/SEOMetadata';
import React, { Suspense, useEffect } from 'react';
import StyledContact from './styles/ContactPageStyles';
import { useIdlePrefetch } from '@/hooks/useIdlePrefetch';

const loadContactSection = () => import('@/components/landing/contact/ContactSection');
const ContactSection = React.lazy(loadContactSection);
const loadFooter = () => import('@/components/landing/Footer');
const Footer = React.lazy(loadFooter);

const ContactPage: React.FC = () => {
  useIdlePrefetch([loadContactSection, loadFooter]);
  useEffect(() => { window.track('contact_page_visited') }, []);

  return (
    <>
      <SEOMetadata
        title="Contact Us – AxionQuant Financial Data API"
        description="Get in touch with AxionQuant for sales, support, or partnership inquiries. We're here to help you integrate our financial data API."
        canonicalUrl="https://axionquant.com/contact"
      />
      <StyledContact>
        <div className="hero">
          <div className="graphic" aria-hidden="true">
            <video
              src="https://cdn.studio14a.com/axion/contact/2R.mp4"
              autoPlay
              muted
              loop
              playsInline
            />

          <video
              src="https://cdn.studio14a.com/axion/contact/1L.mp4"
              className="right"
              autoPlay
              muted
              loop
              playsInline
            />

          </div>
          <div className="content">
            <h1 className="serif">Get in Touch</h1>
            <p>
              Questions about our financial data API, market data, or enterprise plans?
              We'd love to hear from you.
              Fill out the form below or reach out to us through one of our channels.
            </p>
          </div>
        </div>

        <Suspense fallback={null}>
        <ContactSection/>

        <Footer />
        </Suspense>
      </StyledContact>
    </>
  );
};

export default ContactPage;

